import { extractYouTubeVideoId } from "../../sns/extractor/youtube-embed-extractor";
import { normalizeTikTokVideoUrl } from "../../sns/extractor/tiktok-embed-extractor";
import { normalizeInstagramPermalinkForEmbed } from "../../sns/extractor/instagram-embed-extractor";
import { buildFacebookPluginPostIframeSrc } from "../../sns/preview-manager/render/embed/facebook-embed-render";

export function buildMaximizeEmbedUrl(url: string, platform: string): string | null {
    const rawUrl = String(url || "").trim();
    if (!rawUrl || !platform) return null;

    switch (platform) {
        case "youtube": {
            const videoId = extractYouTubeVideoId(rawUrl);
            if (!videoId) return null;
            return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
        }
        case "tiktok": {
            const normalized = normalizeTikTokVideoUrl(rawUrl);
            if (!normalized) return null;
            const match = normalized.match(/\/video\/(\d+)/i);
            if (!match?.[1]) return null;
            // Deliberately /player/v1/ (TikTok's documented Embed Player API),
            // not /embed/v2/ (TikTok's other, undocumented embed endpoint) —
            // /embed/v2/ was the source of the "overload-protect triggered"
            // errors reported in ISS-02-187.
            return `https://www.tiktok.com/player/v1/${match[1]}?autoplay=1`;
        }
        case "instagram": {
            const permalink = normalizeInstagramPermalinkForEmbed(rawUrl);
            if (!permalink) return null;
            const match = permalink.match(/instagram\.com\/(?:p|reel|tv)\/([a-zA-Z0-9_-]+)/i);
            if (!match?.[1]) return null;
            return `https://www.instagram.com/p/${match[1]}/embed/`;
        }
        case "x": {
            const match = rawUrl.match(/(?:twitter\.com|x\.com)\/[^/\s]+\/status\/(\d+)/i);
            if (!match?.[1]) return null;
            const origin =
                typeof globalThis.location !== "undefined" ? encodeURIComponent(globalThis.location.origin) : "";
            return `https://platform.twitter.com/embed/Tweet.html?id=${match[1]}&origin=${origin}`;
        }
        case "facebook": {
            return buildFacebookPluginPostIframeSrc(rawUrl, { showText: true, width: 500 });
        }
        default:
            return null;
    }
}
